<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>HR Evaluation</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Department</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="dept" @change="filterInstructors" :items="dept_list" item-text="name" item-value="id" label="Department" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Employee Payment Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="selectedPaymentSection" 
                            :items="employee_payment_section_list" item-text="name" item-value="id" 
                            @change="filterInstructors" label="Payment Section" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12" v-if="filteredInstructorList.length">
                        <p class="padding-bot"><b>Instructor List</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="filteredInstructorList" item-text="name" item-value="id" label="Instructor" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12" v-if="ay && dept && instructor">
                        <p class="padding-bot"><b></b></p>
                        <br />
                        <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetch()"> Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{appraisal_credit_list}} -->

            <v-card class="box" v-if="appraisal_credit_list !=''">
                <v-data-table :headers="headers" :items="appraisal_credit_list">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>Evaluation</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.credit_point_obtained`]="{ item }">
                        <v-text-field
                            class="padding-bot"
                            outlined
                            dense
                            type="number"
                            :disabled="item.isapplicable"
                            @change="setFlag(item)"
                            v-model="item.credit_point_obtained"
                            :rules="[v => v <= item.max_marks || 'Marks should be Less Than Max Marks']"
                        ></v-text-field>
                    </template>
                    <template v-slot:[`item.isapplicable`]="{ item }">
                        <v-checkbox dense @change="onApplicableChange(item)" v-model="item.isapplicable" color="success"></v-checkbox>
                    </template>
                </v-data-table>
                <v-row justify="center" dense>
                    <v-btn color="warning" @click="saveAppraisalCreditMarks()" :disabled="!this.is_final_approved  || !this.save_marks">Save</v-btn>
                </v-row>
                <v-row justify="center" dense v-if="!this.is_final_approved">
                    <p style="color: red;">Marks Are Already Approved...</p>
                </v-row>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            snackbar_msg: "",
            save_marks: true,
            color: "",
            snackbar: false,
            overlay: false,
            instructor_list: [],
            employee_payment_section_list:[],
            selectedPaymentSection: null,
            filteredInstructorList: [],
            instructor: null,
            ay_list: [],
            ay: "",
            appraisal_credit_list: [],
            is_final_approved: false,
            dept_list: [],
            dept: null,
            headers: [
                { text: "Sr No", value: "srno" },
                { text: "Credit", value: "name" },
                { text: "Credit Points Alloted", value: "max_marks" },
                { text: "Credit Points Obtained", value: "credit_point_obtained" },
                { text: "Criteria", value: "criteria" },
                { text: "Is Not Applicable", value: "isapplicable" },
            ],
        }),
        methods: {
            filterInstructors() {
                this.filteredInstructorList = this.instructor_list.filter(inst => {
                    const matchesDepartment = this.dept ? inst.department_id === this.dept : true;
                    const matchesPaymentSection = this.selectedPaymentSection ? inst.employeepaymentsection_id === this.selectedPaymentSection : true;
                    return matchesDepartment && matchesPaymentSection;
                });
            },
            onApplicableChange(item) {
                if (item.isapplicable) {
                    item.credit_point_obtained = 0;
                }
            },
            setFlag(item) {
                if (item.credit_point_obtained > item.max_marks) {
                    this.save_marks = false;
                } else {
                    this.save_marks = true;
                }
                return this.save_marks;
            },
            saveAppraisalCreditMarks() {
                var credit_ids = [];
                var credit_amount = [];
                var not_applicable_ids = [];
                // for (var i = 0; i < this.appraisal_credit_list.length; i++) {
                //     if (!this.appraisal_credit_list[i].isapplicable == true) {
                //         credit_ids.push(this.appraisal_credit_list[i].credit_id);
                //         credit_amount.push(this.appraisal_credit_list[i].credit_point_obtained);
                //         not_applicable_ids.push(this.appraisal_credit_list[i].isapplicable)
                //     }
                // }
                 for (var i = 0; i < this.appraisal_credit_list.length; i++) {
                    let item = this.appraisal_credit_list[i];
                    credit_ids.push(item.credit_id);
                    credit_amount.push(item.credit_point_obtained || 0);
                    not_applicable_ids.push(item.isapplicable || false);
                }
                //alert("credit_ids--"+credit_ids)
                // alert("credit_amount--"+credit_amount)
                //return
                const formData = {
                    ay: this.ay,
                    instructor: this.instructor,
                    credit_ids: credit_ids,
                    credit_amount: credit_amount,
                    not_applicable_ids: not_applicable_ids,
                };
                axios
                    .post("/Appraisal/saveAppraisalCreditMarks", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.appraisal_credit_list = res.data.appraisal_credit_list;
                            this.showSnackbar("green", "Marks Saved Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            async getDeptInst() {
                (this.instructor_list = []), (this.instructor = null);
                const data = {
                    dept: this.dept,
                };
                try {
                    const res = await axios.post("/Appraisal/getDeptInst", data);
                    if (res.data.flag == "YES") {
                        this.instructor_list = res.data.instructor_list;
                        this.filterInstructors();
                    }
                } catch (err) {
                    this.showSnackbar("red", "Something Went Wrong");
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                } finally {
                }
            },
            fetch() {
                this.overlay = true;
                this.loader = true;
                const formData = {
                    ay: this.ay,
                    instructor: this.instructor,
                };
                axios
                    .post("/Appraisal/fetchEvaluationData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.appraisal_credit_list = res.data.appraisal_credit_list;
                            this.is_final_approved = res.data.allowed_save;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            onLoad() {
                axios
                    .post("/Appraisal/getHrEvaluationData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay_list = res.data.ay_list;
                            this.dept_list = res.data.dept_list;
                            this.instructor_list = res.data.instructor_list;
                            this.employee_payment_section_list=res.data.employee_payment_section_list
                            this.ay = res.data.cay;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped></style>
